import React, { useRef, useState, useMemo } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import useNewGameBarCharts from '@/pages/intelligence/pages/Following/_hook/useCommonBarCharts';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import useCommonLineCharts from '@/pages/intelligence/pages/Following/_hook/useCommonLineCharts';
import useSinglePieCharts from '@/pages/intelligence/components/Chart/hooks/useSinglePieCharts';
import { createDataSourceMetricForValue } from '@/pages/intelligence/pages/Following/_config/util';
import { LINE_GRID_TOP } from '@/pages/intelligence/pages/TopCharts/_config/echarts';

export default function VisualisCommon(props: any) {
  const {
    APPID,
    barOrPieData,
    fetchParams,
    lineData,
    dateType,
    isVisualisLoading,
    chartType = 'bar',
    orderTypeInfo,
    titleNow = '',
    topChartsType = '',
    isNodata,
    entityType,
    metric,
    chartsInstance,
  } = props;

  // console.log('VisualisCommon', props);

  const cardRef = useRef(null);
  // 柱状图相关hooks
  const { seriesData: barSeriesData, barNameList } = useNewGameBarCharts(
    metric,
    barOrPieData,
  );
  const [chartLoading, setChartLoading] = useState(true);
  //获取柱状图hooks
  const { barOption } = useBarCharts({
    seriesData: barSeriesData,
    setChartLoading,
    barOrPieData: barOrPieData,
    titleNow,
    // dataSourceEachers: [],
    barNameList,
    gameIdKeyName: APPID,
    imageType: entityType,
    cardWidth: cardRef?.current?.clientWidth,
    ifNeedSourceImg: false,
    startDate: fetchParams?.start_date,
    endDate: fetchParams?.end_date,
  });
  // 折线图相关hooks
  const {
    seriesData: lineSeriesData,
    xAxisData: lineXAxisData,
    yAxisFormatter: lineYAxisFormatter,
    lineLegendsCustomMade,
  } = useCommonLineCharts(metric, lineData, dateType);

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineXAxisData, //x轴 label 数据
    lineSeriesData, // 折线 数据
    legendsCustomMade: lineLegendsCustomMade, // 图例
    yAxisFormatter: lineYAxisFormatter, // y轴格式化函数
    splitNumber: 4, // y轴显示个数
    isxLabelDate: true, //x轴label默认展示日期
    dateType,
    legendStyle: '',
    topChartsType: ['D2', 'D3', 'D7', 'D15', 'D31'].includes(titleNow) ? 'retention' : entityType == 'company' ? 'following-common-company' : 'following-common',
    imageType: entityType,
    titleNow,
    gridConfig: {
      top: LINE_GRID_TOP,
      bottom: 62,
    },
  });

  const getMetrisDatas = (data: any, metricValue: string) => {
    if (!data) return null;
    const metrics = data?.metric_list || [];
    return metrics.find((item: any) => createDataSourceMetricForValue(item?.metric, item?.data_source) === metricValue);
  };
  //通用饼图数据格式
  const pieSeriesData = useMemo(() => {
    let arrList: any = [];
    if (Array.isArray(barOrPieData) && barOrPieData?.length > 0) {
      barOrPieData?.map((item: any, i: number): any => {
        arrList.push({
          app_id: item?.[APPID],
          name: item.name,
          value: getMetrisDatas(item, metric)?.value
            ? getMetrisDatas(item, metric).value
            : 0,
          cover: item.cover,
        });
      });
    }
    return arrList;
  }, [barOrPieData, metric, chartType]);

  // 获取饼图hooks
  const { pieOption } = useSinglePieCharts({
    chartsInstance,
    pieData: pieSeriesData,
    pieTitle: titleNow,
    setChartLoading,
    chartType,
    imageType: entityType,
    titleNow,
    startDate: fetchParams?.start_date,
    endDate: fetchParams?.end_date,
  });

  return (
    <div ref={cardRef} style={{ width: '100%' }}>
      <ChartsIndex
        ref={chartsInstance}
        echartsData={{}}
        chartLoading={isVisualisLoading || chartLoading}
        barOption={{
          ...barOption,
          grid: {
            left: '5px',
            right: '0%',
            top: '25px',
            bottom: '3px',
            containLabel: true,
          },
        }}
        lineOption={lineOption}
        pieOption={pieOption}
        chartType={chartType}
        isNodata={!barOrPieData?.length}
      />
    </div>
  );
}
